export default __webpack_public_path__ + "static/media/leviathan-crop.a1532cb9.jpg";